import React from 'react'
import { Button } from 'antd'
import styled from 'styled-components'
import SuccessIcon from '../../../asserts/icon/questionnaire/ic_questionnaire_pre_medical_success.svg'

const Container = styled.div`
  width: 576px;
  text-align: center;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  h1 {
    color: #323f4a;
    font-size: 36px;
    margin-bottom: 36px;
  }
  img {
    margin-bottom: 36px;
  }
  .content {
    color: #52606c;
    font-size: 16px;
    font-family: 'Heebo';
    font-weight: 400;
    letter-spacing: 0.3px;
    line-height: 150%;
  }
  button {
    width: 229px;
    height: 48px;
    margin-top: 20px;
  }
`

export default function WaiverCompletedPage(props) {
  const { proceed } = props
  return (
    <Container>
      <img src={SuccessIcon} alt="completed" />
      <div className="content">
        <p>
          Thank you for completing our introductory forms. A member of our
          Concierge team will reach out to you shortly to schedule the rest of
          your Apeiron appointments.
        </p>
        <p>
          Prior to coming in for your Assessment, we'll need to learn more about
          your current lifestyle. This will help us personalize your assessment
          and tailor your results and recommendations to your goals and needs.
          We look forward to seeing you soon!
        </p>
        <Button size="large" type="primary" onClick={proceed}>
          PROCEED
        </Button>
      </div>
    </Container>
  )
}
